import { types } from 'mobx-state-tree';

import { BaseVehicle } from '../definitions/InsCommon';


const Motorcycle = BaseVehicle
    .named('Motorcycle')
    .props({
        isSportsBike: types.maybe(types.boolean),
    });

export default Motorcycle;
